<template>

  <div>
    <v-divider></v-divider>
    <Notification :notify="notify" />

    <div class="row">
      <div class="col">
        <v-simple-table>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">Organization</th>
                <th class="text-left">Date of Payment</th>
                <th class="text-left">Amount</th>
                <th class="text-left">Payment Made By</th>
                <th class="text-left">Payment Confirmation</th>
                <th class="text-left">Zoho Reference No</th>
                <th style="width: 0px"></th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{{ item.OrganizationName }}</td>
                <td>{{ item.DateOfPayment }}</td>
                <td>{{ item.Amount }}</td>
                <td>{{ item.PaymentMadeBy }}</td>
                <td>{{ item.PaymentConfirmed }}</td>
                <td>{{ item.ReferenceNo }}</td>
                <td></td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </div>
    </div>

    <div class="row">
      <div class="col">
        
      </div>
    </div>
  </div>
</template>
<script>
import * as api from "@/api";
import Notification from "@/components/Notification";
import ConfirmationDialog from "@/components/ConfirmationDialog";

export default {
  name: "CancelPurchaseOrderDetails",
  components: {
    Notification,
    ConfirmationDialog,
  },
  watch: {},
  created() {
    this.getPurchaseOrder(this.$route.params.id);
  },
  methods: {
    getPurchaseOrder(id) {
      new Promise((resolve, reject) => {
        api
          .getByID("purchase-order", id)
          .then((response) => {
            resolve(response);
            console.log(response.data);
            this.item = response.data;
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    onSelect(obj) {
      console.log(obj);
      this.$emit("onSelect", obj);
    },
  },
  data() {
    return {
      item: {},
      list: [],
      details: [],
      notify: {
        type: 0,
        message: "",
        errors: [],
      },
    };
  },
};
</script>


// WEBPACK FOOTER //
// src/components/PO-Cancellation/CancelPurchaseOrderDetails.vue